export default __webpack_public_path__ + "d09bfbb63a631aa7dec3b624dd6ab911.gltf";